import { authenticatedApiFetch } from '../../common/helpers';
import { call, onSuccess } from 'actionware';
import * as R from 'ramda';
import { push } from 'connected-react-router';
import {
  mapAccountStatisticsFromJson,
  mapLenderAccountDetailFromJson,
  mapLenderAccountFromJson,
  mapLoanDetailFromJson,
  mapLoanFromJson
} from './accountMappers';
import { matchPath } from 'react-router';

const parseLenderAccounts = R.compose(
  R.map(mapLenderAccountFromJson),
  R.defaultTo([])
);

export async function fetchLenderAccounts() {
  const result = await authenticatedApiFetch(`accounts`);
  return parseLenderAccounts(result);
}

export async function fetchLenderAccount(id) {
  return authenticatedApiFetch(`account/${id}`).then(
    mapLenderAccountDetailFromJson
  );
}

export async function fetchLoans(lenderAccountId) {
  return authenticatedApiFetch(`account/${lenderAccountId}/loans`)
    .then(R.defaultTo([]))
    .then(R.map(mapLoanFromJson));
}

export async function fetchLoan(loanId, lenderAccountId) {
  return await authenticatedApiFetch(`loan/${loanId}/${lenderAccountId}`).then(
    mapLoanDetailFromJson
  );
}

export async function fetchStatistics(id) {
  return await authenticatedApiFetch(`account/${id}/statistics`)
    .then(R.defaultTo([]))
    .then(R.map(mapAccountStatisticsFromJson));
}

export function filterDisplayedLoans(displayActive) {
  return displayActive;
}

export function setSelectedAccount(accountId) {
  return accountId;
}

// Side effects
// ------------------------------

onSuccess(fetchLenderAccounts, ({ store: { dispatch, getState } }) => {
  // If we are in the account section and we haven't selected any account yet
  // we redirect to the route relative to the first account
  const {
    account: { selectedAccountId, accounts },
    router: { location }
  } = getState();
  if (
    !selectedAccountId &&
    matchPath(location.pathname, { path: '/account', exact: true })
  ) {
    const [firstAccount] = accounts;
    if (firstAccount) {
      dispatch(push(`/account/${firstAccount.id}`));
    }
  }
});

onSuccess(setSelectedAccount, ({ payload }) => {
  // note: payload is the accountId
  call(fetchLenderAccount, payload);
});

onSuccess(fetchLenderAccount, ({ store: { getState } }) => {
  const { account: { selectedAccountDetails: { id } } } = getState();
  call(fetchLoans, id);
  // call(fetchStatistics, id);
});

onSuccess(fetchLoans, ({ store: { getState } }) => {
  const { account: { loans, selectedAccountDetails } } = getState();
  const [firstLoan] = loans
    .filter(({ status }) => ['disbursed', 'closed'].includes(status))
    .sort((loan1, loan2) => (loan1.status['disbursed'] ? 1 : -1));

  if (firstLoan) {
    call(fetchLoan, firstLoan.id, selectedAccountDetails.id);
  }
});
